export default {
	sendingNotification:'notifyingSchoolNotFound',
	notificationSent:'schoolNotFoundNotfSent',
	memberidsuffix:'memberidsuffix',
	memberidprefix:'memberidprefix',
	savingparticipants:'savingparticipants'
}



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/fields.js